export default __webpack_public_path__ + "static/media/Pink pop1.f46b8bbb.jpg";